import { DataVisualizationRequestType, DataVisualizationRequest } from "types/data-visualization.types"
import { FctServiceReturn } from "services/services.types"
import { dataVisualizationRestService } from "services/data-visualization-rest"

export interface DataVisualizationService {
  fetchData: (
    requestType: DataVisualizationRequestType,
    request: DataVisualizationRequest,
  ) => Promise<FctServiceReturn<any>>
}

class DataVisualizationServiceImpl implements DataVisualizationService {
  async fetchData(requestType: DataVisualizationRequestType, request: DataVisualizationRequest): Promise<any> {
    try {
      switch (requestType) {
        case DataVisualizationRequestType.EVOLUTION_OVER_TIME_ANALYSIS:
          return await dataVisualizationRestService.fetchOpsAnalysis(request)

        default:
          throw new Error(`Unsupported request type: ${requestType}`)
      }
    } catch (error) {
      console.error("Error fetching data visualization data:", error)
      return {
        type: "FETCH_DATA_VISUALIZATION_ERROR",
        payload: {
          request: {
            method: "POST",
            url: "/data-visualization/ops-analysis",
            params: {},
          },
          data: null,
        },
      }
    }
  }
}

// Export singleton instance
export const dataVisualizationService = new DataVisualizationServiceImpl()
